import {useGetCustomTags} from '../../../../core/repositories/companyRepository';
import {CustomTagCompaniesFrameContainer} from './container';
import {CustomTagCompaniesFrameSkeleton} from './presentation';

type Props = {
  filterQuery: {
    limit?: number;
    minEmployeeCount?: number;
    maxEmployeeCount?: number;
    workAttractiveConditionIDs?: number[];
  };
  withOdd?: boolean;
  handleSetTotalCount?: (key: string, count: number) => void;
};

export const CustomTagCompaniesFrameContainers: React.FC<Props> = ({
  filterQuery,
  handleSetTotalCount,
  withOdd = false,
}) => {
  const {data, isLoading} = useGetCustomTags({
    queryParams: {
      companyLimit: filterQuery.limit ?? 100,
      minEmployeeCount:
        filterQuery.minEmployeeCount === 0
          ? undefined
          : filterQuery.minEmployeeCount,
      maxEmployeeCount:
        filterQuery.maxEmployeeCount === 0
          ? undefined
          : filterQuery.maxEmployeeCount,
      workAttractiveConditionIDs: filterQuery.workAttractiveConditionIDs,
    },
  });

  const filteredTags = data?.ok
    ? data.value.result.filter((tag) => tag.companies.length > 0)
    : [];

  return (
    <>
      {isLoading && !data
        ? // ローディング中でデータがまだない場合はSkeletonを表示
          Array.from({length: 3}).map((_, index) => (
            <CustomTagCompaniesFrameSkeleton
              key={`skeleton-${index}`}
              withOdd={withOdd}
            />
          ))
        : // データ取得完了後は実際のコンテンツを表示
          filteredTags.map((tag) => (
            <CustomTagCompaniesFrameContainer
              key={tag.CustomTag.id}
              componentID={`custom-tag-${tag.CustomTag.id}`}
              customTag={tag.CustomTag}
              companies={tag.companies}
              isLoading={false} // データ取得完了後はfalse
              handleSetTotalCount={handleSetTotalCount}
              withOdd={withOdd}
            />
          ))}
    </>
  );
};
